import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { questionTopicConstants } from '../../constants';
import { questionTopicService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionTopicConstants.GETALL_REQUEST });
    const success = (questionTopics: any) => ({ type: questionTopicConstants.GETALL_SUCCESS, payload: questionTopics });
    const failure = (error: any) => ({ type: questionTopicConstants.GETALL_FAILURE, payload: error });

    dispatch(request());
    try {
      const questionTopics = await questionTopicService.getAll();
      dispatch(success(questionTopics));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getQuestionCounts = () => {
  return async (dispatch: any) => {
    try {
      const counts = await questionTopicService.getQuestionCounts();
      return counts;
    } catch (error: any) {
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      return [];
    }
  };
};

const create = (vn_name: string) => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionTopicConstants.CREATE_REQUEST });
    const success = (topic: any) => ({ type: questionTopicConstants.CREATE_SUCCESS, payload: topic });
    const failure = (error: any) => ({ type: questionTopicConstants.CREATE_FAILURE, payload: error });

    dispatch(request());
    try {
      const newTopic = await questionTopicService.create(vn_name);
      dispatch(success(newTopic));
      dispatch(notificationActions.addNotification('Đã tạo chủ đề mới thành công', 'SUCCESS'));
      return newTopic;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };
};

const update = (id: number, vn_name: string) => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionTopicConstants.UPDATE_REQUEST });
    const success = (topic: any) => ({ type: questionTopicConstants.UPDATE_SUCCESS, payload: topic });
    const failure = (error: any) => ({ type: questionTopicConstants.UPDATE_FAILURE, payload: error });

    dispatch(request());
    try {
      const updatedTopic = await questionTopicService.update(id, vn_name);
      dispatch(success(updatedTopic));
      dispatch(notificationActions.addNotification('Đã cập nhật chủ đề thành công', 'SUCCESS'));
      return updatedTopic;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };
};

const deleteTopic = (id: number) => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionTopicConstants.DELETE_REQUEST });
    const success = (id: number) => ({ type: questionTopicConstants.DELETE_SUCCESS, payload: id });
    const failure = (error: any) => ({ type: questionTopicConstants.DELETE_FAILURE, payload: error });

    dispatch(request());
    try {
      const result = await questionTopicService.deleteTopic(id);
      dispatch(success(id));
      dispatch(notificationActions.addNotification(
        `Đã xóa chủ đề (${result.affectedQuestions} câu hỏi bị ảnh hưởng)`, 
        'SUCCESS'
      ));
      return result;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };
};

export const questionTopicActions = {
  getAll,
  getQuestionCounts,
  create,
  update,
  deleteTopic,
};